module.exports = __webpack_public_path__ + "static/media/home_graph_3d.86210410.gif";